import { useHasPermission } from '@contexts/permissions-provider';
import { UserDetailPanel } from '@features/users/components/detail-panel/UserDetailPanel';
import { useUserNavigation } from '@features/users/hooks/use-user-navigation/useUserNavigation';
import * as React from 'react';
import { useParams } from 'react-router-dom';

const UserDetailRoute = React.memo((): React.ReactElement => {
  const { userId } = useParams<{ userId: string }>();
  const canEdit = useHasPermission('Users_Edit_Org');
  const { navigateToUsersList } = useUserNavigation();

  return (
    <UserDetailPanel
      mode={canEdit ? 'edit' : 'view'}
      userId={userId}
      onClose={navigateToUsersList}
    />
  );
});

UserDetailRoute.displayName = 'UserDetailRoute';

export { UserDetailRoute };
